import { CollectionResponse } from "baaanggg"
import { Link } from "react-router-dom"

type Props = {
    collection: CollectionResponse
}

export function CollectionCardV2({ collection }: Props) {
    return <Link to={`/collection/${collection.slug}`}>
        <div
            className="rounded-2.5xl border border-jacarta-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-gray-400 dark:bg-gray-900">
            <img style={{ objectFit: "cover" }} src={collection.thumbUrl ?? "/src/img/logo/transparant_logo.png"} alt="item 1"
                className="w-full aspect-square rounded-[0.625rem]" loading="lazy" />
            <p
                className="mt-5 mb-2 flex items-center font-display text-base text-jacarta-700 dark:text-white">
                {collection.name}
            </p>
            <div className="font-medium text-2xs text-jacarta-700 dark:text-white mb-2">
                Created By <a className="text-accent font-medium">{collection.owner?.username ?? "unknown"}</a>
            </div>
        </div>
    </Link>
}